/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oligo Tm Calculator (Melting Temperature) — Toolverse`)
};

const es_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Tm de Oligos (Temperatura de Fusión) — Toolverse`)
};

const de_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oligo-Tm-Rechner (Schmelztemperatur) — Toolverse`)
};

const nl_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oligo-Tm-calculator (smelttemperatuur) — Toolverse`)
};

const fr_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de Tm d'oligo (température de fusion) — Toolverse`)
};

const it_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di Tm per oligo (temperatura di fusione) — Toolverse`)
};

const pt_br2_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Tm de Oligo (Temperatura de Fusão) — Toolverse`)
};

const pt_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Tm de Oligonucleótidos (Temperatura de Fusão) — Toolverse`)
};

const ja_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリゴTm計算ツール（融解温度） — Toolverse`)
};

const zh_tm_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寡核苷酸 Tm 计算器（解链温度）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_meta_title", locale)
	if (locale === "en") return en_tm_meta_title(inputs)
	if (locale === "es") return es_tm_meta_title(inputs)
	if (locale === "de") return de_tm_meta_title(inputs)
	if (locale === "nl") return nl_tm_meta_title(inputs)
	if (locale === "fr") return fr_tm_meta_title(inputs)
	if (locale === "it") return it_tm_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_tm_meta_title(inputs)
	if (locale === "pt") return pt_tm_meta_title(inputs)
	if (locale === "ja") return ja_tm_meta_title(inputs)
	return zh_tm_meta_title(inputs)
};